/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum BaseWorkspaceRole {
  WORKSPACE_MANAGER = 'workspace_manager',
  ARCHIVIST = 'archivist',
  VIEWER = 'viewer',
  DEACTIVATED = 'deactivated',
}
